// eslint-disable-next-line import/no-anonymous-default-export
export default {
    URL_API: 'https://quizserver.vityazgroup.ru:8501/api/',
        SERVER_SOCKET:'wss://quizserver.vityazgroup.ru:8501',

    // URL_API: 'http://192.168.1.101:8012/api/',
    // SERVER_SOCKET:'ws://192.168.1.101:8100',
    
    URL_LOGIN:'user/login',

    scoreLocalName:{
        risk:'Риск',
        carma:'Карма'
    },
    
}